import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import visits from './modules/visits'
import plans from './modules/plans'
import plannedVisits from './modules/planned-visits'
import regionPlans from './modules/region-plans'
import plannedRegions from './modules/planned-regions'
import regions from './modules/regions'
import workloads from './modules/workloads'
import entities from './modules/entities'
import materials from './modules/materials'
import materialForms from './modules/materials-forms'
import materialsTransactions from './modules/materials-transactions'
import specialties from './modules/specialties'
import profile from './modules/profile'
import exams from './modules/exams'
import dailyReport from './modules/daily-report'
import priceTypes from './modules/price-types'
import notifications from './modules/notifications'
import vacations from './modules/vacations'
import configurations from './modules/configurations'
import config from './modules/config'
import order from './modules/order'
import sync from './modules/sync'
import visitDraft from './modules/visit-draft'
import employeeStock from './modules/employee-stock'
import debtVisits from './modules/debt-visits'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		auth,
		visits,
		dailyReport,
		plans,
		plannedVisits,
		regionPlans,
		plannedRegions,
		regions,
		workloads,
		entities,
		materials,
		materialForms,
		materialsTransactions,
		specialties,
		priceTypes,
		profile,
		exams,
		notifications,
		vacations,
		configurations,
		config,
		order,
		sync,
		visitDraft,
		employeeStock,
		debtVisits
	}
})